var _map = require('lodash.map');

var validator = require('ui-validator');
var v = validator.validators;

var specialties = [{
    displayName: 'Dental',
    name: 'Dental'
  },
  {
    displayName: 'Fertility',
    name: 'Fertility'
  },
  {
    displayName: 'Hair Restoration',
    name: 'Hair Restoration'
  },
  {
    displayName: 'Bariatric',
    name: 'Bariatric'
  }
];

var specialtiesList = _map(specialties, 'name');

var howDidYouHearOpts = [
  'Consultant, lab, vendor or lecture',
  'Print advertisement',
  'Email or online advertisement',
  'Direct mail',
  'Word of mouth or referral',
  'Meeting or tradeshow',
  'Web search',
  'Lending Club Patient Solutions representative',
  'Other or I don\'t know'
];

// We need to validate both of these at once. If we have these separately in the schema, we get a double error message when user enters email of all spaces
var customEmailValidator = validator.createValidator(
  function(options, value, key, attributes) {
    return v.required(options)(value, key, attributes) || v.email(options)(value, key, attributes);
  }
);

var customAlphaNum = validator.createValidator(
  function(options, value, key, attributes) {
    options = options || {};
    if (value && !value.match(/^[a-zA-Z0-9]+$/)) {
      return options.message || 'A valid ' + key + ' is required. It can contain letters and numbers only.';
    }
  }
);

var customNum = validator.createValidator(
  function(options, value, key, attributes) {
    options = options || {};
    if (value && !value.match(/^[0-9]{9}$/)) {
      return options.message || 'A valid ' + key + ' is required. It can numbers with 9 digits only.';
    }
  }
);

var customAlphaSpaces = validator.createValidator(
  function(options, value, key, attributes) {
    options = options || {};
    if (value && !value.match(/^[a-zA-Z0-9\.]+( [a-zA-Z0-9\.]+)*$/)) {
      return options.message || 'A valid ' + key + ' is required. It can contain letters and single spaces only.';
    }
  }
);

var customCharWhitelist = validator.createValidator(
  function(options, value, key, attributes) {
    options = options || {};
    if (value && !value.match(/^[a-zA-Z0-9!$#%&\(\)*+,-\.\/;=?@\[\/\]^_{|} ~\']+$/)) {
      return options.message || 'A valid ' + key + ' is required. It contains invalid characters.';
    }
  }
);

var customPersonName = validator.createValidator(
  function(options, value, key, attributes) {
    options = options || {};
    if (value && !value.match(/^[a-zA-Z'\-. ]+$/)) {
      return options.message || 'A valid ' + key + ' is required. It contains invalid characters.';
    }
  }
);

var customStreetName = validator.createValidator(
  function(options, value, key, attributes) {
    options = options || {};
    if (value && !value.match(/^[a-zA-Z0-9',\-.# ]+$/)) {
      return options.message || 'A valid ' + key + ' is required. It contains invalid characters.';
    }
  }
);

var customCity = validator.createValidator(
  function(options, value, key, attributes) {
    options = options || {};
    if (value && !value.match(/^[a-zA-Z]+(?:[\s-]+[a-zA-Z]+)*$/)) {
      return options.message || 'A valid ' + key + ' is required. It contains invalid characters.';
    }
  }
);

var customPasswordValidator = validator.createValidator(
  function(options, value, key, attributes) {
    options = options || {};
    if (!value || !value.match(/^(?=.*\d+)(?=.*[a-zA-Z])[0-9a-zA-Z!@#$%]{8,30}$/)) {
      return options.message || 'Password must contain 8 characters with at least one letter and one number; special characters can only include !, @, #, $ or %.';
    }
  }
);

var additionalInfoRequired = validator.createValidator(
  function(options, value, key, attributes) {
    if (options.field === attributes[options.howDidYouHearAboutUs]) {
      return v.required(options)(value, key, attributes);
    }
  }
);

function testEmail() {
  var validChars = 'abcdefghijklmnopqrstuvwxyz';
  var text = '';
  for (var i = 0; i < 15; i++) {
    text += validChars.charAt(Math.floor(Math.random() * validChars.length));
  }
  return text + '@tlcqa.com';
}

var mockCreateAccountContent = function() {
  return {
    'email': testEmail(),
    'password': 'welcome1',
    'confirmPassword': 'welcome1'
  };
};

var mockPI1Content = function() {
  return {
    'specialty': 'Dental',
    'practiceDBA': 'some practice',
    'doctorFirstName': 'DocFirst',
    'doctorLastName': 'DocLast',
    'phone': 4158675309,
    'zipCode': 94041,
    'firstName': 'CoordFirst',
    'lastName': 'CoordLast',
    'email': testEmail(),
    'howDidYouHear': 'Email or online advertisement'
  };
};

module.exports = {
  specialties: specialties,
  specialtiesList: specialtiesList,
  howDidYouHearOpts: howDidYouHearOpts,
  customEmailValidator: customEmailValidator,
  customPasswordValidator: customPasswordValidator,
  customNumValidator: customNum,
  customAlphaNumValidator: customAlphaNum,
  customAlphaSpacesValidator: customAlphaSpaces,
  customCharWhitelistValidator: customCharWhitelist,
  customPersonNameValidator: customPersonName,
  customStreetNameValidator: customStreetName,
  customCityValidator: customCity,
  additionalInfoRequiredValidator: additionalInfoRequired,
  testEmail: testEmail,
  mockCreateAccountContent: mockCreateAccountContent,
  mockPI1Content: mockPI1Content
};

